import IButton from "@/interfaces/IButton";

export default function (callback: () => void): IButton {
  return {
    i18n: "common.previousStep",
    variant: "outline-info",
    onClick: callback,
  };
}
